import { DataService } from '../../../services/data_service';
import { getAssistentConfigBWL } from './items/assistent_config_bwl';
import { getAssistentConfigCO2 } from './items/assistent_config_co2';
import { getAssistentConfigWaerme } from './items/assistent_config_waerme';
import { getAssistentConfigEingangsHinweise } from './items/assistent_config_hinweise';
import { getAssistentConfigHinweisSachanlagen } from './items/assistent_config_hinweise_sachanlagen';
import { getAssistentConfigKennziffern } from './items/assistent_config_kennziffern';
import { getAssistentConfigKonfig } from './items/assistent_config_config';
import { getAssistentConfigKraftstoffe } from './items/assistent_config_kraftstoffe';
import { getAssistentConfigMaschinenUndFahrzeuge } from './items/assistent_config_masch_fzg';
import { getAssistentConfigSonstige } from './items/assistent_config_sonstige_daten';
import { getAssistentConfigStandorte } from './items/assistent_config_standorte';
import { getAssistentConfigStrom, getAssistentConfigEigenStrom } from './items/assistent_config_strom';
import { getAssistentConfigUnternehmen } from './items/assistent_config_unternehmensdaten';
import { getAssistentConfigVeranstaltungen } from './items/assistent_config_veranstaltungen';
import { getAssistentConfigWasser } from './items/assistent_config_wasser';
import { getSachanlagenStructure } from '../functions/getEnergiedatenStructure';
import { IDs } from '../../../helpers/IDs';
import { isEnableCO2, isEnableErneuerbareEnergien, isEnableFahrzeuge, isEnableGHG, isEnableMaschinen, isEnableSachanlagen, isEnableStandorte, isEnableVeranstaltungen } from './assistent_helpers';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormConfigItem } from '../../../core/forms/WFormFramework';
import { WFormData } from '../../../core/forms/WFormData';
import { getAssistentConfigCO2Scope3, getAssistentConfigCO2Scope3Item } from './items/assistent_config_co2scope3';
import { getCO2Scope3Auswahl } from '../functions/getCO2Scope3Auswahl';
import { getCO2Scope3StructureAllgemein, getCO2Scope3StructureNachgelagert, getCO2Scope3StructureVorgelagert } from '../functions/getCO2Scope3Structure';
// import { getAssistentConfigEingangsAbfrage } from './items/assistent_config_eingangsitem';
// import { getAssistentConfigImport } from './items/assistent_config_import';
// import { getAssistentConfigKontrolle } from './items/assistent_config_kontrolle';

export interface AssistentCustomFormItem {
    question: string;     // Die Frage
    type: string;         // Der Datentyp (checkbox, number, text o.Ä.)
    key: string;          // Der Parameter-Key für die temporäre Datenhaltung
    preset: any;          // Der voreingestellte Wert
    disabled?: boolean;   // Gesperrt?
    helpIconKey?: string; // Wenn vorhanden Hilfe-Symbol anzeigen
}

export interface AssistentItem {
    style?: React.CSSProperties,
    group?: string,
    collapsible?: string; // Key derEbene ein- oder auszuklappen. Beispiele Siehe: assistent_config_vsme_basis.tsx
    disableOnClick?: boolean;
    gliederung?: string; // z.B. 1., 1.1. 2.1.3 usw. also eine klassische Gliederung (nur für die Anzeige)
    gliederung2?: string; // z.B. 1., 1.1. 2.1.3 usw. also eine klassische Gliederung (nur für die Anzeige)
    name?: string; // Titel für Menü
    dataName?: string; // Text zum einbetten
    description?: string; // Erläuterungstext für den Eingabeschritt
    type?: string; // CustomForm, EntityForm, CustomElement, Info
    customFormItems?: AssistentCustomFormItem[]; // Die Liste der CustomFormItems
    customElements?: JSX.Element[]; // Für CustomElement
    entity?: string; // Entity ggf. fürs Formular
    module?: string; // Optional
    entityBrowseOld?: boolean; // Wenn true kann man sich durch die Formulare alle bereits existierenden Datensätze blättern
    entityAddNew?: boolean; // Wenn true, wird ein leeres Formular für einen neuen Datensatz angezeigt
    disablePruefer?: boolean; // Wenn true erfolgt keine Datenprüfung
    disableIndicator?: boolean;
    disableMenueCheckbox?: boolean;
    singleItem?: boolean; // Es gibt nur einen Datensatz für diese Datenart
    configFlag?: string; // Name einer Variable aus der Datenhaltung, nur wenn diese true ist, wird der schritt ausgeführt
    infoTextKey?: string; // Wenn vorhanden Systemtext über dem Formular anzeigen
    infoTextStyle?: React.CSSProperties;
    customFormConfig?: any; // Explizit Felder ausblenden oder auf readonly setzen
    selectOptionAsRadio?: boolean; // Selects als Knöpfe darstellen
    disableFieldSelectDefaultOptions?: any;
    externalDescriptionElement?: JSX.Element | JSX.Element[] | string | ((formData: any) => JSX.Element);
    addLabel?: string;
    customCssStyle?: any;
    colBg?: string;
    vorhandenName?: string;
    formGroupOrder?: Array<any>;
    additionalFormItems?: WFormConfigItem[];
    customFilter?: (dataItem: any) => boolean;
    updateAssistentItem?: (dataItem: any) => AssistentItem;
    customOnChange?: (dataItem: any, data: any, contextService?: any, prevDataItem?: any) => void;
    customAllowContinue?: (dataItem: any) => boolean; // Prüft, ob wir fortfahren dürfen
    customOnSaveDone?: (entity: string, dataItem: any) => void;
    blockContinue?: boolean; // true, wenn wir NICHT fortfahren dürfen
    blockMessage?: string | JSX.Element; // Nachricht, falls wir blockieren müssen
    blockText?: string;
    extraFormElementBefore?: any;
    extraFormElementAfter?: any;
    getExtraElement?: (
        isFirst: boolean, standortSelected: any, jahr: number, entity: any, values: any, setValues: (values: any) => void,
        disabled?: boolean
    ) => JSX.Element;
    bundleFilterFunc?: (bundle: any, data: any) => void;
    customTopElement?: (entity: string, item: any, callback?: (data: any) => void) => JSX.Element;
    onFormChangeInteractive?(data: WFormData, onValueChange: (name: string, value: any) => void): void;
    callBeforeDelete?: (data: any, callback: () => void) => void;
    callBeforeOnFormSave?: (data: any, callback: () => void) => void;
    callBeforeOnFormAutoSave?: (data: any, callback: () => void) => void;
    callOnChangeRunIndex?: () => void;
}

export function getAssistentConfig(
    standort: any, data: any, jahr: number, dataService: DataService, triggerService: TriggerService,
    onRoutingChange: (routing: any) => void, clearPruefState: () => void, isAdmin: boolean, bereichKey: string, routing: any
) {
    const konfiguration: any[] = data[IDs.ENT_KONFIGURATION] || [];
    const enableErneuerbareEnergien: boolean = isEnableErneuerbareEnergien(konfiguration);
    const enableFahrzeuge: boolean = isEnableFahrzeuge(konfiguration);
    const enableMaschinen: boolean = isEnableMaschinen(konfiguration);
    const enableStandorte: boolean = isEnableStandorte(konfiguration);
    const enableVeranstaltungen: boolean = isEnableVeranstaltungen(konfiguration);
    const enableCO2: boolean = isEnableCO2(konfiguration);
    const enableSachanlagen: boolean = isEnableSachanlagen(konfiguration);
    const enableGHG: boolean = isEnableGHG(konfiguration);

    const config: AssistentItem[] = [];
    const ignoreScopes: string[] = ['brennstoff'];

    // config.push(getAssistentConfigEingangsAbfrage(data));
    config.push(getAssistentConfigKonfig(data, onRoutingChange, isAdmin, bereichKey));
    config.push(getAssistentConfigUnternehmen(data, triggerService));
    if (enableStandorte) {
        config.push(getAssistentConfigStandorte(data, dataService, triggerService));
    }
    if (enableVeranstaltungen) {
        config.push(getAssistentConfigVeranstaltungen(data, dataService, triggerService));
    }
    // config.push(getAssistentConfigImport(standort, data, onRoutingChange, clearPruefState));
    config.push(getAssistentConfigEingangsHinweise(data));
    config.push(getAssistentConfigStrom(standort, data, jahr, triggerService));

    if (enableErneuerbareEnergien) {
        config.push(getAssistentConfigEigenStrom(standort, data));
    }
    config.push(getAssistentConfigWaerme(standort, data, jahr, triggerService));
    // config.push(getAssistentConfigEigenwaerme());
    config.push(getAssistentConfigKraftstoffe(standort, data, jahr, triggerService));
    if (/*enableCO2 && */enableSachanlagen && enableGHG) {
        config.push(getAssistentConfigHinweisSachanlagen(standort, data, jahr));
        // config.push(getAssistentConfigAngemieteteRaeumlichkeiten(data, triggerService));
        // config.push(getAssistentConfigEigeneRaeumlichkeiten(data, triggerService));
        // config.push(getAssistentConfigAngemieteteFahrzeuge(data, triggerService));
        if (standort) {
            const structSachanlagen = getSachanlagenStructure();
            structSachanlagen.forEach((s: any) => {
                if (checkEnergiedatenAuswahl(data, standort.tid, jahr, s)) {
                    config.push(s.getItemAssistentConfig(data, triggerService));
                }
            });
        }
    }
    config.push(getAssistentConfigWasser(data, triggerService));
    config.push(getAssistentConfigCO2());
    config.push(getAssistentConfigBWL(data));
    config.push(getAssistentConfigKennziffern(data));
    config.push(getAssistentConfigSonstige());

    if (enableErneuerbareEnergien || enableFahrzeuge || enableMaschinen) {
        config.push(getAssistentConfigMaschinenUndFahrzeuge(standort, data, onRoutingChange, routing));
    }

    // Ab hier Scope 3
    if (enableCO2) {
        config.push(getAssistentConfigCO2Scope3(standort, data, jahr));
        if (standort) {
            const modul: string = (data || {}).MODUL_SELECTED || null;
            const hasEmittenten: boolean = (data || {})[IDs.ENT_CO2_SCOPE3_EMITTENTEN].some((emittent: any) =>
                emittent.jahr === jahr && (emittent.standort_tid_orig || emittent.standort_tid) === standort.tid
            );
            const scope3Auswahl = getCO2Scope3Auswahl(data, standort, jahr, jahr).sort((a: string, b: string) => {
                return getScope3number(a, bereichKey, modul) - getScope3number(b, bereichKey, modul);
            });
            scope3Auswahl.forEach((scope: string) => {
                // inkl. bei keiner Auswahl "Weitere Emissionsquellen" ausblenden
                if (ignoreScopes.indexOf(scope) !== -1 || (scope === 'emittenten' && !hasEmittenten)) {
                    return;
                }
                const item_subscope = getAssistentConfigCO2Scope3Item(scope, data, triggerService, bereichKey, modul);
                if (item_subscope) {
                    config.push(item_subscope);
                }
            });
        }
    }

    return config;
}

export function getScope3number(auswahlItem: string, bereichKey: string, modul?: string) {
    const structAll = [
        ...getCO2Scope3StructureVorgelagert(bereichKey, modul),
        ...getCO2Scope3StructureNachgelagert(bereichKey, modul),
        ...getCO2Scope3StructureAllgemein()
    ];
    const struct: any = structAll.find((s: any) => s.key === auswahlItem && !s.ignore);
    if (!struct) {
        // console.log('S?', structAll, auswahlItem);
        return 0;
    }
    const name = struct.name_short || struct.name;
    const split = name.split(' ');
    const split2 = split[0].split('.');
    if (split2.length === 1) {
        return +split2[0];
    } else {
        return +(split2[0] + '.' + split2[1]);
    }
    // return +split[0].replace('.', '');
}

export function checkEnergiedatenAuswahl(data: any, standortTid: number, jahr: number, struc: any) {
    const fnd = (data[IDs.ENT_ENERGIEDATEN_AUSWAHL] || [])
        .find((r: any) => r.standort_tid_orig === standortTid && r.jahr === jahr && r.name === struc.key && r.category === struc.category);
    if (fnd && fnd.auswahl === 1) {
        return true;
    }
    return false;
}
